import React, { useEffect, useState } from "react";
import firebase from "../services/FirebaseService";
import { Link, Redirect  } from "react-router-dom";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/profile.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { AuthProvider, IfFirebaseAuthed, IfFirebaseUnAuthed } from "../context/FirebaseAuthContext";
import UserService from "../services/UserService";

const Info = ({ match }) => {

	const userService = new UserService();

	const [ userObject, setUser ] = useState();
	const [ userUID, setUserUID ] = useState();
	const [ loading, setLoading ] = useState(true);
	const [ personal, setPersonal ] = useState(false);
	const [ error, setError ] = useState("");
	const [ redirect, setRedirect ] = useState(false);

	useEffect(() => {

		firebase.auth().onAuthStateChanged(async (user) => {
			if(user) {

				setUserUID(user.uid);

				setLoading(true);
				try {
					const tempUserData = await userService.getUserInfo(match.params.id ? match.params.id : user.uid);
					
					setPersonal(match.params.id === user.uid ? true : false);
					setUser(tempUserData);
					setError("");
					setLoading(false);
				}
				catch(error) {
					setError(error.code);
					setLoading(false);
				}
			}
			else {
				setRedirect(true);
			}
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [match.params.id]);

	if(loading) {
		return <></>;
	}

	if(redirect || error) {
		return <Redirect to="/auth/login" />;
	}

	if(!match.params.id) {
		return <Redirect to={"/profile/" + userUID} />;
	}
	
	return (
		<>
			<section id="profile">
				<div id="main">
					<img alt="personal" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia.istockphoto.com%2Fvectors%2Fprofile-placeholder-image-gray-silhouette-no-photo-vector-id1016744004%3Fk%3D6%26m%3D1016744004%26s%3D170667a%26w%3D0%26h%3DdsibM8vNYIJDN1wtB8SWex8M99vl6a9NoDsobZ9dUCo%3D&f=1&nofb=1" />
					<div id="stats">
						<h1>{ userObject.name }</h1>
						{ userObject.isStaff && <h3>Staff</h3> }
						{ personal && <button onClick={() => firebase.auth().signOut()}><FontAwesomeIcon icon={faSignOutAlt} /> Log out</button> }
					</div>
				</div>
				<div id="information">
					{ 
						userObject.about && 
						<div>
							<h2>About</h2>
							<p>{userObject.about}</p>
						</div>
					}
					
					{ 
						userObject.location && 
						<div>
							<h2>Location</h2>
							<p>{userObject.location}</p>
						</div>
					}	
					{ personal && <div id="edit">
						<Link to="/edit-profile"><FontAwesomeIcon icon={faCog} /> Edit Profile</Link>	
					</div> }
				</div>
			</section>
		</>
	)
};

const ProfilePage = ({ match }) => {

	return (
		<>
			<AuthProvider>
				<IfFirebaseAuthed>
					<Navbar />
					<Info match={match} />
					<Footer />
				</IfFirebaseAuthed>
				<IfFirebaseUnAuthed>
					<Redirect to="/auth/login" />
				</IfFirebaseUnAuthed>
			</AuthProvider>
		</>
	)
};

export default ProfilePage;